import { createFeatureSelector, createSelector } from '@ngrx/store';
import { QueryResultsModel, HttpExtenstionsModel } from '../../_base/crud';
import { TeamMembersState } from '../_reducers/team-members.reducers';
import { each } from 'lodash-es';
import { TeamMember } from '../_models/team-member.model';

export const selectTeamMembersState = createFeatureSelector<TeamMembersState>('teamMembers');

export const selectTeamMemberById = (teamMemberId: number) =>
  createSelector(
    selectTeamMembersState,
    (teamMembersState) => teamMembersState.entities[teamMemberId],
  );

export const selectTeamMembersPageLoading = createSelector(
  selectTeamMembersState,
  (teamMembersState) => {
    return teamMembersState.listLoading;
  },
);

export const selectTeamMembersShowInitWaitingMessage = createSelector(
  selectTeamMembersState,
  (teamMembersState) => teamMembersState.showInitWaitingMessage,
);

export const selectTeamMemberError = createSelector(
  selectTeamMembersState,
  (teamMembersState) => teamMembersState.error,
);
export const selectTeamMembersInStore = createSelector(
  selectTeamMembersState,
  (teamMembersState) => {
    const items: TeamMember[] = [];
    each(teamMembersState.entities, (element) => {
      items.push(element);
    });
    const httpExtension = new HttpExtenstionsModel();
    const result: TeamMember[] = httpExtension.sortArray(
      items,
      teamMembersState.lastQuery.sortField,
      teamMembersState.lastQuery.sortOrder,
    );
    return new QueryResultsModel(result, teamMembersState.totalCount);
  },
);

export const selectHasTeamMembersInStore = createSelector(selectTeamMembersState, (queryResult) => {
  return queryResult.totalCount;
});
